const PENDING_ORDER_FIELDS_EXCLUDED_FROM_ADDRESS = [
  'commande',
  'freeDelivery',
  'lastUpdateOrder',
  'managementFee',
  'orderType',
  'shopId',
  'totalPriceOrder',
  'totalProductPriceOrder',
  'totalProductPriceWithPromo',
  'id'
];

export const getPendingOrderCartResetPayload = () => ({
  commande: {},
  totalPriceOrder: 0,
  totalProductPriceOrder: 0,
  totalProductPriceWithPromo: 0,
});

export const getEmptyPendingOrderPayload = () => ({
  shopId: null,
  address: null,
  ...getPendingOrderCartResetPayload(),
});

export const sanitizePendingOrderAddress = (address: any) => {
  if (!address || typeof address !== 'object' || Array.isArray(address)) {
    return address;
  }

  const sanitizedAddress = { ...address };
  PENDING_ORDER_FIELDS_EXCLUDED_FROM_ADDRESS.forEach((field) => {
    delete sanitizedAddress[field];
  });
  return sanitizedAddress;
};

export const shouldResetPendingOrderCart = (
  previousPendingOrder: any,
  shopId: string | null | undefined,
  orderType: string | null | undefined,
) => {
  const previousShopId =
    previousPendingOrder?.shopId ?? previousPendingOrder?.address?.shopId;
  const previousOrderType =
    previousPendingOrder?.orderType ??
    previousPendingOrder?.address?.orderType;

  const shopChanged = !!previousShopId && !!shopId && previousShopId !== shopId;
  const orderTypeChanged =
    !!previousOrderType && !!orderType && previousOrderType !== orderType;

  return shopChanged || orderTypeChanged;
};
